module.exports = __webpack_public_path__ + "img/04.01a2403b.jpg";